import React from "react";
import { FaBriefcase } from "react-icons/fa6";

const JobTimeline = [
  {
    from: "1 December 2024",
    to: "Present",
    companyName: "GMIT LIMITED",
    title: "Frontend Developer",
    description:
      "Collaborating with senior developers on a large-scale application. Responsibilities include performance optimization, API development, and ensuring best coding practices. Delivering code within deadlines while assisting team members.",
    techStack: [
      "PHP",
      "LARAVEL",
      "MYSQL",
      "FLOWBITE",
      "JQUERY",
      "AJAX",
      "HTML",
      "CSS",
      "JAVASCRIPT",
      "TAILWIND",
      "BOOTSTRAP",
    ],
    icon: <FaBriefcase />,
  },
  {
    from: "11 November 2022",
    to: "31 January 2023",
    companyName: "Pakapepe.com",
    title: "Full Stack Developer",
    description:
      "Developed and maintained high-performance, responsive web applications using JavaScript, React.js, and vanilla JavaScript. Worked with backend APIs, authentication, and database optimization.",
    techStack: [
      "EXPRESS.JS",
      "NODE.JS",
      "MONGODB",
      "JWT",
      "FIREBASE",
      "REACT.JS",
      "HTML",
      "CSS",
      "JAVASCRIPT",
      "TAILWIND",
      "BOOTSTRAP",
    ],
    icon: <FaBriefcase />,
  },
];

const Experience = () => {
  return (
    <div className="w-full px-[8%] mx-auto  py-12 bg-gray-700">
      <h1 className="text-4xl font-bold  text-[#00A9FF] mb-10">
        Work Experience
      </h1>

      <div className="space-y-6">
        {JobTimeline.map((job, index) => (
          <div
            key={index}
            className="relative bg-gray-900/80 shadow-lg border border-[#00A9FF] rounded-xl p-6 transition-all hover:scale-[1.02] hover:shadow-lg"
          >
            

            <div className="flex items-center gap-4">
              <div className="p-3 bg-[#00A9FF] text-white rounded-full shadow-md">
                {job.icon}
              </div>
              <h2 className="text-2xl font-semibold text-[#00A9FF]">
                {job.title}
              </h2>
            </div>

            <p className="text-gray-400 mt-2">
              <span className="font-medium text-gray-200">
                {job.companyName}
              </span>{" "}
              | {job.from} - {job.to}
            </p>

            <p className="text-gray-300 mt-4">{job.description}</p>

            {/* Tech Stack */}
            <div className="flex flex-wrap gap-2 mt-4">
              {job.techStack.map((tech, i) => (
                <span
                  key={i}
                  className="bg-[#00A9FF]/20 text-[#00A9FF] text-xs px-3 py-1 rounded-full font-medium"
                >
                  {tech}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Experience;
